import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center mb-4" }
const _hoisted_2 = { class: "text-truncate" }

import { ref, onMounted, watch, inject, computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { api } from '@/services/api';
  import type Client from '@/models/client';
  import ErrorsView from '@/views/ErrorsView.vue';
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ClientView',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();
  const client = ref<Client | null>(null);
  const showDeleteDialog = ref(false);
  const deleteLoading = ref(false);
  const showCopiedAlert = ref(false);
  const downloadLoading = ref(false);
  const showErrorSnackbar = ref(false);
  const errorMessage = ref('');
  const generatedUrl = computed(() => {
    const baseUrl = process.env.VUE_APP_LANDING_PAGE_URL;
    console.log(baseUrl);
    return `${baseUrl}${route.params.id}`;
  });
  
  // Inject the refresh method
  const refreshClients = inject('refreshClients') as () => Promise<void>;
  
  const getTokenStatusColor = (status?: string) => {
    switch (status) {
      case 'Active':
        return 'green-darken-1';
      case 'Expired':
      case 'Inactive':
      case 'Disabled':
      case 'Invalid':
      case 'Revoked':
        return 'red-darken-2';
      case 'PendingAuthorization':
        return 'orange-darken-1';
      default:
        return 'grey-darken-1';
    }
  };

  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(generatedUrl.value);
      showCopiedAlert.value = true;
      setTimeout(() => {
        showCopiedAlert.value = false;
      }, 2000);
    } catch (err) {
      console.error('Failed to copy URL:', err);
    }
  };
  
  const fetchClient = async () => {
    try {
      // todo aram implement no clientId in params OR client not found
      const clientId = route.params.id as string;
      const response = await api.getClient(clientId)
      client.value = response;
    } catch (error) {
      console.error('Error fetching client:', error);
    }
  };
  
  // Watch for changes in the route params
  watch(
    () => route.params.id,
    (newId) => {
      if (newId) {
        fetchClient();
      }
    }
  );
  
  onMounted(() => {
    fetchClient();
  });
  
  // Add delete client method
  const deleteClient = async () => {
    try {
      deleteLoading.value = true;
      const clientId = route.params.id as string;
      await api.deleteClient(clientId);
      
      // Refresh the clients list
      await refreshClients();
      
      // Close the dialog and redirect to home
      showDeleteDialog.value = false;
      router.push('/');
    } catch (error) {
      console.error('Error deleting client:', error);
      // You might want to show an error message to the user here
    } finally {
      deleteLoading.value = false;
    }
  };

  const downloadReport = async () => {
    try {
      downloadLoading.value = true;
      const clientId = route.params.id as string;
      const blob = await api.downloadReport(clientId);
      
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      const now = new Date();
      const dateTime = now.toISOString().slice(0, 16).replace('T', '_');
      link.download = `payment-report-${client?.value?.name}-${dateTime}.csv`;
      
      // Trigger the download
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading report:', error);
      // Refresh client data to get updated errors
      await fetchClient();
      
      // Show error notification
      errorMessage.value = 'Failed to download report';
      showErrorSnackbar.value = true;
    } finally {
      downloadLoading.value = false;
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
        icon: "mdi-arrow-left",
        class: "mb-4"
      }),
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "flex-grow-1" }, "Client Details", -1)),
        _createVNode(_component_v_btn, {
          color: "error",
          "prepend-icon": "mdi-delete",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDeleteDialog.value = true))
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Delete Client ")
          ])),
          _: 1
        })
      ]),
      _createVNode(_component_v_card, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-domain",
                        class: "mr-2"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("Company Name")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(client.value?.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-account",
                        class: "mr-2"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("Contact Name")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(client.value?.contactName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-email",
                        class: "mr-2"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("Contact Email")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(client.value?.contactEmail), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-key",
                        class: "mr-2"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("Token Status")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_chip, {
                            color: getTokenStatusColor(client.value?.tokenStatus),
                            size: "small",
                            variant: "elevated",
                            class: "mt-1 font-weight-medium"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(client.value?.tokenStatus || 'Unknown'), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-link",
                        class: "mr-2"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("Landing Page URL")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_subtitle, { class: "d-flex align-center mt-1" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_2, _toDisplayString(generatedUrl.value), 1),
                          _createVNode(_component_v_btn, {
                            icon: "mdi-content-copy",
                            size: "small",
                            variant: "text",
                            class: "ml-2",
                            onClick: copyUrl
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_snackbar, {
                        modelValue: showCopiedAlert.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showCopiedAlert).value = $event)),
                        color: "success",
                        timeout: "2000"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode(" URL copied to clipboard! ")
                        ])),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(ErrorsView, {
                    errors: client.value?.errors,
                    onErrorDeleted: fetchClient
                  }, null, 8, ["errors"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        color: "primary",
        class: "mt-4",
        loading: downloadLoading.value,
        disabled: downloadLoading.value,
        "prepend-icon": "mdi-download",
        onClick: downloadReport
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode(" Download Report ")
        ])),
        _: 1
      }, 8, ["loading", "disabled"]),
      _createVNode(_component_v_dialog, {
        modelValue: showDeleteDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDeleteDialog).value = $event)),
        "max-width": "500px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("Delete Client")
                ])),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode(" Are you sure you want to delete this client? This action cannot be undone. ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showDeleteDialog.value = false))
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode(" Cancel ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    variant: "text",
                    loading: deleteLoading.value,
                    onClick: deleteClient
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode(" Delete ")
                    ])),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_snackbar, {
        modelValue: showErrorSnackbar.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showErrorSnackbar).value = $event)),
        color: "error",
        timeout: 3000,
        location: "top"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMessage.value), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})